import { Anchor, Box, Button, Card, Center, Container, PasswordInput, TextInput } from '@mantine/core';
import { IconArrowRight } from '@tabler/icons-react';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ErrorMessage from '../components/ErrorMessage';
import Footer from '../components/Footer';
import Metadata from '../components/Metadata';
import Spinner from '../components/Spinner';
import { Page } from '../constants/pageTitles';
import mainLogo from '../logo.png';
import { loginUser } from '../store/authSlice';

const LoginPage = () => {
  const dispatch = useDispatch();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');

  const { isLoginLoading, error } = useSelector((state) => state.auth);

  const submitForm = (e) => {
    e.preventDefault();
    dispatch(loginUser({ email, password }));
    setPassword('');
  };

  return (
    <div>
      <Metadata title={`${Page['login']}`} />
      <Center pt={60} h="100%">
        <Container size="xs" w="100%">
          <Card withBorder p="lg">
            <Box ta="center" mb="lg">
              <img src={mainLogo} alt="Releva" style={{ maxWidth: '100%', height: 'auto' }} />
            </Box>

            <Box component="form" ta="left" onSubmit={(e) => submitForm(e)}>
              <TextInput
                size="lg"
                name="email"
                type="email"
                label="Email"
                value={email}
                placeholder="Your Email"
                onChange={(e) => setEmail(e.target.value)}
                mb="md"
              />

              <PasswordInput
                size="lg"
                name="password"
                label="Password"
                value={password}
                placeholder="Your Password"
                onChange={(e) => setPassword(e.target.value)}
                mb="md"
              />

              <ErrorMessage message={error} />

              <Box ta="right" mb="md">
                <Anchor href="#/resetPassword">Forgot your password?</Anchor>
              </Box>

              {isLoginLoading ? (
                <Spinner />
              ) : (
                <Button fullWidth size="lg" type="submit" disabled={!email || !password}>
                  Sign In <IconArrowRight />
                </Button>
              )}
            </Box>
          </Card>
          <Footer />
        </Container>
      </Center>
    </div>
  );
};

export default LoginPage;
